import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { cloneDeep } from 'lodash';
import { Message, ConfirmationService, ConfirmEventType, MenuItem } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { MsPermissionService } from 'src/app/services/ms-permission.service';

@Component({
  selector: 'app-ms-evaluation',
  templateUrl: './ms-evaluation.component.html',
  styleUrls: ['./ms-evaluation.component.scss', '../../../../mystery-shopper/mystery-shopper.component.scss']

})
export class MsEvaluationComponent {

  isInternalPM: boolean = false;
  statusType: string = 'Pending';
  hasStatusDB: boolean = true;
  isSkelition = false;
  header: string = this.translate("Evaluation");
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-refresh',
      link: '/ms/project',
    }
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Project'), link: '/ms/project' },
    { name: this.translate('Evaluation'), link: '/ms/evaluation' },
  ];
  messages: Message[] = [];
  projectId: string = '';
  project: any;
  channels: Array<any> = []
  basicChannels: Array<any> = []
  basicChannelsProject: Array<any> = []
  branchChannels: Array<any> = []
  branches: Array<any> = []
  selectedBranches: any[] = [];
  selectedBranchesProject: any[] = [];
  isCheckAll: boolean = false;
  pmComment: string = '';
  iPMComment: string = '';
  stepStatus: any = [];
  hasBranches: boolean = false;
  selectChanel: any
  selectBranch: any
  selectVisit: any
  criterias: any;
  factors: any[] = [];
  visits: any;
  enquiries: any;
  evaluations: any;
  filteredVisits: any[] = [];
  canSave: boolean = false;
  canUpdate: boolean = false;
  filteredCriterias: any[] = [];
  filteredEvaluation: any[] = [];
  evaluationStatus: string = "";
  filteredFactors: any[] = [];
  filteredEnquiries: any[] = [];
  showEnquiryModal = false;
  selectedEnquiries: any[] = [];


  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.projectId = params['projectId'];
      if (this.projectId) {
        this.selectedBranches = [];
        this.canSave = false;
        this.selectChanel = null;
        this.selectBranch = null;
        this.getProject(this.projectId).then(() => {

          let pm = MsPermissionService.checkUserPermissions(this.project);
          if (pm == true) {
            this.isInternalPM = true;
          } else if (pm == false) {
            this.router.navigate(['/ms/project'])
            return;
          }

          return Promise.all([
            this.getBranches(),
            this.getFactors(),
            this.getEnquiries(),
            this.getVisits(),
          ]);
        }).then(() => {
          this.getEvaluations()
          this.isSkelition = false;
        }).catch((error) => {
        });
      }

    })
  }

  isSubmitValid(): boolean {
    if (this.factors.length > 0) {
      const allGradesValid = this.factors.every((factor: { grade: number | undefined; }) => {
        return factor.grade !== undefined && factor.grade <= 5;
      });
    }
    return true;
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  async getProject(id: string) {
    try {
      this.isSkelition = true;
      let res = await this.dataService.getData(`ms-project/${id}`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.project = res.data.data;
      this.channels = res.data.channels;
      this.basicChannels = res.data.channels.filter((item: any) => item.type == 'Basic')
      this.basicChannelsProject = res.data.channels.filter((item: any) => item.type == 'Basic')
      this.hasBranches = this.basicChannels.some(channel => channel.name === "Branches");
      this.selectedBranchesProject = res.data.channels.filter((item: any) => item.type == 'Branch')
      this.selectedBranches = res.data.channels.filter((item: any) => item.type == 'Branch')
      this.branchChannels = res.data.channels.filter((item: any) => item.type == 'Branch')
      this.isSkelition = false;
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  async getBranches() {
    this.isSkelition = true;
    try {
      let res = await this.dataService.getData('ou-type/branches');
      if (res.error) return
      this.branches = res.data;
      this.selectedBranches.forEach((selectedBranch, index) => {
        const matchingBranchIndex = this.branches.findIndex(branch => branch._id == selectedBranch.branchId);
        if (matchingBranchIndex !== -1) {
          this.selectedBranches[index].name = this.selectedBranches[index].name + " ( " + this.branches[matchingBranchIndex].location.name + " ) ";
        }
      });
      this.isSkelition = false;
    } catch (error) {
      console.log(error)
    }
  }

  convertToDate(dateObject: any) {
    const date = new Date(dateObject.year, dateObject.month - 1, dateObject.day);
    const formattedDate = date.toDateString();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedTime = `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}`;
    return formattedDate;
  }

  onChannelChange() {
    this.canSave = false;
    this.canUpdate = false;
    this.filteredEvaluation = [];
    this.evaluationStatus = "";
    this.filteredCriterias = this.criterias.filter((criteria: { channel: any; }) => criteria.channel._id === this.selectChanel._id);
    this.factors = [];
    this.filteredCriterias.forEach(criteria => {
      criteria['sub-criterias'].forEach((subCriteria: any) => {
        subCriteria['factors'].forEach((factor: any) => {
          this.factors.push(factor);
        });
      });
    });

    this.filteredEnquiries = [];
    this.selectedEnquiries = [];
    this.filteredEnquiries = this.enquiries.filter((enquiry: { factorId: { _id: any; }; }) => {
      return this.factors.some((factor: { _id: any; }) => factor._id === enquiry.factorId._id);
    });

    if (this.selectChanel.name != 'Branches') {
      console.log("this.visits", this.visits)
      this.filteredVisits = this.visits.filter((visit: { channel: any; }) => visit.channel === this.selectChanel._id);
    } else {
      this.filteredVisits = [];
    }
  }

  onBranchChange() {
    this.canSave = false;
    this.canUpdate = false;
    this.filteredEvaluation = [];
    this.evaluationStatus = "";
    this.filteredVisits = this.visits.filter((visit: { branch: any; }) => visit.branch === this.selectBranch._id);
  }

  onVisitChange() {
    let visitTime = this.selectVisit.date;
    let channel = this.selectChanel?._id;

    if (this.selectChanel && this.selectChanel.name === 'Branches') {
      let branch = this.selectBranch?._id;
      this.filteredEvaluation = this.evaluations.filter((evaluation: { visitTime: any; channel: any; branch: any; }) => {
        return evaluation.visitTime === visitTime &&
          evaluation.channel._id === channel &&
          evaluation.branch._id === branch;
      });
    } else {
      this.filteredEvaluation = this.evaluations.filter((evaluation: { visitTime: any; channel: any; }) => {
        return evaluation.visitTime === visitTime &&
          evaluation.channel._id === channel;
      });
    }

    this.filteredEvaluation.forEach((filtEvaluation: { enquiries: any[]; }) => {
      filtEvaluation.enquiries.forEach((filtEnquiry, index) => {
        const matchingBranchIndex = this.enquiries.findIndex((enquiry: { _id: any; }) => enquiry._id === filtEnquiry._id);
        if (matchingBranchIndex !== -1) {
          filtEvaluation.enquiries[index].enquiry = this.enquiries[matchingBranchIndex].enquiry;
        }
      });
    });

    this.filteredEvaluation.forEach((filtEvaluation: { factors: any[]; }) => {
      filtEvaluation.factors.forEach((filtFactor, index) => {
        const matchingBranchIndex = this.factors.findIndex((factor: { _id: any; }) => factor._id === filtFactor._id);
        if (matchingBranchIndex !== -1) {
          filtEvaluation.factors[index].factor = this.factors[matchingBranchIndex].factor;
        }
      });
    });

    console.log("filteredEvaluation", this.filteredEvaluation);

    if (this.filteredEvaluation.length > 0 && (this.isInternalPM || this.isInternalUserPM(this.project.internalPm))) {
      this.pmComment = this.filteredEvaluation[0].vendorComments;
    }

    if (this.filteredEvaluation.length == 0 && !(this.isInternalPM || this.isInternalUserPM(this.project.internalPm)) && this.statusType != 'Approved') {
      this.canSave = true;
    }
  }

  async getVisits() {
    try {
      let res = await this.dataService.getData(`ms-sessions/visit/${this.projectId}`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.visits = res.data;

      console.log("this.visits", this.visits);

      res.data.forEach((visit: any, index: number) => {
        this.visits[index].dropdownlabel = this.formatDate(visit.date);
      });
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  async getFactors() {
    try {
      let res = await this.dataService.getData(`ms-criteria/project/${this.projectId}/1/1000`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.criterias = res.data.data
      console.log('FACTORS', this.criterias);
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  async getEnquiries() {
    try {
      let res = await this.dataService.getData(`ms-enquiry/project/1/1000/${this.projectId}`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.enquiries = res.data;
      console.log('ENQUIRIES', this.enquiries);
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  async getEvaluations() {
    this.isSkelition = true;
    try {
      let res = await this.dataService.getData('ms-evaluation/project/' + this.projectId);
      if (res.error) return
      this.evaluations = res.data;

      for (let channelIndex = this.basicChannels.length - 1; channelIndex >= 0; channelIndex--) {
        const channel = this.basicChannels[channelIndex];
        if (channel.name === 'Branches') {
          const BranchEvaluations = this.evaluations.filter((evaluation: any) => evaluation.channel.name === 'Branches');
          if (this.selectedBranches.length > 0) {
            let branchCount = this.selectedBranches.length;
            for (let branchIndex = this.selectedBranches.length - 1; branchIndex >= 0; branchIndex--) {
              const branch = this.selectedBranches[branchIndex];
              const visitData = this.visits.filter((visit: any) => visit.branch === branch._id);
              if (visitData.length > 0) {
                let visitDataCount = visitData.length;
                for (let visitIndex = visitData.length - 1; visitIndex >= 0; visitIndex--) {
                  const visit = visitData[visitIndex];
                  const Flag = BranchEvaluations.some((evaluation: any) => {
                    return evaluation.visitTime === visit.date && evaluation.channel._id === channel._id && evaluation.branch._id === branch._id;
                  });
                  if (Flag) {
                    this.visits.splice(this.visits.indexOf(visit), 1);
                    visitDataCount--;
                  }
                }
                if (visitDataCount === 0) {
                  this.selectedBranches.splice(branchIndex, 1);
                  branchCount--;
                }
                if (branchCount === 0) {
                  this.basicChannels.splice(channelIndex, 1);
                }
              }
              else {
                this.selectedBranches.splice(branchIndex, 1);
                branchCount--;

                if (branchCount === 0) {
                  this.basicChannels.splice(channelIndex, 1);
                }
              }
            }
          }
        } else {
          const visitData = this.visits.filter((visit: any) => visit.channel === channel._id);
          if (visitData.length > 0) {
            let visitDataCount = visitData.length;
            for (let visitIndex = visitData.length - 1; visitIndex >= 0; visitIndex--) {
              const visit = visitData[visitIndex];
              const Flag = this.evaluations.some((evaluation: any) => {
                return evaluation.visitTime === visit.date && evaluation.channel._id === channel._id;
              });
              if (Flag) {
                this.visits.splice(this.visits.indexOf(visit), 1);
                visitDataCount--;
              }
            }
            if (visitDataCount === 0) {
              this.basicChannels.splice(channelIndex, 1);
            }
          }
          else {
            this.basicChannels.splice(channelIndex, 1);
          }
        }
      }
      this.isSkelition = false;
    } catch (error) {
      console.log(error)
    }
  }

  async saveEvaluation() {
    if (this.isSubmitValid()) {
      this.factors.forEach((factor: { percentage: number; grade: number; }) => {
        factor.percentage = (factor.grade / 5) * 100;
      });
      let data: any = {
        projectId: this.projectId,
        factors: this.factors,
        enquiries: this.selectedEnquiries,
        vendorComments: this.pmComment,
        channel: this.selectChanel._id,
        visitTime: this.selectVisit.date,
      };

      if (this.selectChanel.name === 'Branches') {
        data.branch = this.selectBranch._id;
      }

      this.isSkelition = true;
      let res = await this.dataService.postData('ms-evaluation', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: this.translate('') },
      ]
      this.ngOnInit();
      return;
    }
    else {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Grades & Comments') },
      ]
      return;
    }
  }

  async updateEvaluation() {
    if (this.isSubmitValid()) {
      this.filteredEvaluation[0].factors.forEach((factor: { percentage: number; grade: number; }) => {
        factor.percentage = (factor.grade / 5) * 100;
      });
      let id = this.filteredEvaluation[0]._id;
      let data: any = {
        projectId: this.projectId,
        factors: this.filteredEvaluation[0].factors,
        enquiries: this.filteredEvaluation[0].enquiries,
        vendorComments: this.pmComment,
      };

      this.isSkelition = true;
      let res = await this.dataService.postData('ms-evaluation/' + id, data, 'PUT', false);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: this.translate('') },
      ]

      this.ngOnInit();
      return;
    }
    else {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Grades & Comments') },
      ]
      return;
    }
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  GetBranchName(id: string) {
    const branch = this.branchChannels.find((branch: any) => branch._id === id);
    return branch ? branch.name : '';
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const formattedDate = `${hours}:${minutes} ${day}-${month}-${year} `;
    return formattedDate;
  }

  viewEvaluation(evaluation: any) {
    this.selectChanel = null;
    this.selectBranch = null;
    this.canUpdate = false;
    this.canSave = false;
    this.filteredEvaluation = [];
    this.evaluationStatus = "";
    this.filteredEvaluation.push(evaluation);
    this.filteredEvaluation.forEach((filtEvaluation: { enquiries: any[]; }) => {
      filtEvaluation.enquiries.forEach((filtEnquiry, index) => {
        const matchingBranchIndex = this.enquiries.findIndex((enquiry: { _id: any; }) => enquiry._id === filtEnquiry._id);
        if (matchingBranchIndex !== -1) {
          filtEvaluation.enquiries[index].enquiry = this.enquiries[matchingBranchIndex].enquiry;
        }
      });
    });

    this.filteredCriterias = this.criterias.filter((criteria: { channel: any; }) => criteria.channel._id === evaluation.channel._id);
    this.factors = [];
    this.filteredCriterias.forEach(criteria => {
      criteria['sub-criterias'].forEach((subCriteria: any) => {
        subCriteria['factors'].forEach((factor: any) => {
          this.factors.push(factor);
        });
      });
    });

    this.filteredEvaluation.forEach((filtEvaluation: { factors: any[]; }) => {
      filtEvaluation.factors.forEach((filtFactor, index) => {
        const matchingBranchIndex = this.factors.findIndex((factor: { _id: any; }) => factor._id === filtFactor._id);
        if (matchingBranchIndex !== -1) {
          filtEvaluation.factors[index].factor = this.factors[matchingBranchIndex].factor;
        }
      });
    });

    this.getEvaluationStatus(this.filteredEvaluation);

    if (this.filteredEvaluation.length > 0) {
      this.pmComment = this.filteredEvaluation[0].vendorComments;
    }

    if (this.filteredEvaluation.length > 0 && !(this.isInternalPM || this.isInternalUserPM(this.project.internalPm)) && this.evaluationStatus != 'Approved' && this.evaluationStatus != 'Pending') {
      this.canUpdate = true;
    }
  }

  checkAll(checked: boolean) {
    if (!checked) {
      this.isCheckAll = true;
      this.selectedEnquiries = [...this.filteredEnquiries];
    } else {
      this.isCheckAll = false;
      this.selectedEnquiries = [];
    }
  }

  addRemoveEnquiry(enquiry: any) {
    const index = this.selectedEnquiries.findIndex(e => e._id === enquiry._id);
    if (index !== -1) {
      this.selectedEnquiries.splice(index, 1);
    } else {
      this.selectedEnquiries.push(enquiry);
    }
  }

  enquirySelected(enquiry: any) {
    return this.selectedEnquiries.findIndex(e => e._id === enquiry._id) !== -1;
  }

  async updateEvaluationStatus(status: string) {
    if (this.isSubmitValid()) {
      this.confirm({
        message: this.translate('Are you sure you want to do this?'),
        header: this.translate('Confirmation message'),
        icon: 'pi pi-exclamation-triangle',
        action: async () => {
          try {
            this.isSkelition = true;
            let evaId;
            if (!(this.isInternalPM || this.isInternalUserPM(this.project.internalPm))) {
              if (this.canUpdate) {
                this.filteredEvaluation[0].factors.forEach((factor: { percentage: number; grade: number; }) => {
                  factor.percentage = (factor.grade / 5) * 100;
                });
                let id = this.filteredEvaluation[0]._id;
                let data: any = {
                  projectId: this.projectId,
                  factors: this.filteredEvaluation[0].factors,
                  enquiries: this.filteredEvaluation[0].enquiries,
                  vendorComments: this.pmComment,
                };
                let res = await this.dataService.postData('ms-evaluation/' + id, data, 'PUT', false);
                evaId = this.filteredEvaluation[0]._id;
              }
              else {
                this.factors.forEach((factor: { percentage: number; grade: number; }) => {
                  factor.percentage = (factor.grade / 5) * 100;
                });
                let data: any = {
                  projectId: this.projectId,
                  factors: this.factors,
                  enquiries: this.selectedEnquiries,
                  vendorComments: this.pmComment,
                  channel: this.selectChanel._id,
                  visitTime: this.selectVisit.date,
                };

                if (this.selectChanel.name === 'Branches') {
                  data.branch = this.selectBranch._id;
                }
                let res = await this.dataService.postData('ms-evaluation', data);
                evaId = res.data._id;

              }
            }

            if (this.filteredEvaluation.length > 0) {
              evaId = this.filteredEvaluation[0]._id;
            }

            let data: any = {
              internalPMComments: this.iPMComment,
              approvalStatus: status,
            };
            let res = await this.dataService.postData('ms-evaluation/' + evaId, data, 'PUT', false);
            if (res.error) {
              this.messages = [
                { severity: 'error', summary: this.translate('error'), detail: res.msg },
              ]
              return;
            }
            this.messages = [
              { severity: 'success', summary: this.translate('success'), detail: this.translate('') },
            ]
            this.isSkelition = false;
            this.canUpdate = false;
            this.evaluationStatus = '';
            this.pmComment = "";
            this.filteredEvaluation = [];
            this.iPMComment = "";
            this.ngOnInit();
          } catch (error) {
            console.log(error);
          }
        },
      });
    }
  }

  getEvaluationStatus(evaluation: any) {
    if (Array.isArray(evaluation) && evaluation.length > 0) {
      if (evaluation[0].approvalStatus != undefined) {
        this.evaluationStatus = evaluation[0].approvalStatus;
        if (this.evaluationStatus == 'Redo' || this.evaluationStatus == 'Change') {
          this.iPMComment = evaluation[0].internalPMComments;
        }
      }
    }
  }

  isInternalUserPM(internalPm: any) {
    const uid: string = localStorage.getItem('uid') ?? '';
    if (internalPm) {
      if (Array.isArray(internalPm) && internalPm.length > 0) {
        return uid === internalPm[0]._id;
      } else if (typeof internalPm === 'object' && internalPm._id) {
        return uid === internalPm._id;
      }
    }
    return false;
  }
}
